import {
  CheckCircleFilled,
  SafetyCertificateFilled,
  StopOutlined,
} from "@ant-design/icons";
import { Button, Modal, Space, Tag } from "antd";
import React from "react";
import { $t } from "~/i18n.js";
import { _parseDateTime } from "~/lib/localize.js";
import { colors } from "~/theme/colors.js";

export const AuthorisationInfoModal = ({
  visible = false,
  onClose = () => {},
  authorisation = {},
  pilotName = "",
  canRevoke = false,
  onRevoke = () => {},
  loading = false,
}) => {
  return (
    <Modal
      title={
        <Space>
          <SafetyCertificateFilled style={{ color: colors.groen_dark }} />
          {$t("Dagelijkse Autorisatie Info")}
        </Space>
      }
      open={visible}
      onCancel={onClose}
      footer={[
        canRevoke && (
          <Button
            key="revoke"
            danger
            icon={<StopOutlined />}
            onClick={onRevoke}
            loading={loading}
          >
            {$t("Intrekken")}
          </Button>
        ),
        <Button key="close" type="primary" onClick={onClose}>
          {$t("Sluiten")}
        </Button>,
      ]}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        {pilotName && (
          <div>
            <strong>{$t("Piloot")}:</strong>
            <div style={{ marginTop: 4 }}>{pilotName}</div>
          </div>
        )}

        <div>
          <strong>{$t("Status")}:</strong>
          <div style={{ marginTop: 4 }}>
            <Tag color="green">{$t("Geautoriseerd")}</Tag>
          </div>
        </div>

        <div>
          <strong>{$t("Beperkingen")}:</strong>
          <div style={{ marginTop: 4 }}>
            <p>{authorisation.limitations || $t("Geen")}</p>
          </div>
        </div>

        <div>
          <strong>{$t("Geautoriseerd door")}:</strong>
          <div style={{ marginTop: 4 }}>{authorisation.name}</div>
        </div>

        <div>
          <strong>{$t("Datum")}:</strong>
          <div style={{ marginTop: 4 }}>
            {_parseDateTime(authorisation.date)}
          </div>
        </div>
      </Space>
    </Modal>
  );
};
